var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import AlertDeliveryButtons from '../../atoms/DeliveryIcons';
import { AlertBodyRightWrapper, AlertsBodySmallText } from './subcomponents';
var AlertBodyRight = function (_a) {
    var _b;
    var currentAlertData = _a.currentAlertData, alertFormData = _a.alertFormData, deliveryRef = _a.deliveryRef;
    var t = useTranslation().t;
    var alertId = currentAlertData.id, allDeliveryMethods = currentAlertData.allDeliveryMethods;
    var labelId = "".concat(alertId, "-delivery-options-group");
    return (_jsxs(AlertBodyRightWrapper, __assign({ "data-test": "AlertBodyRightWrapper" }, { children: [_jsx(AlertsBodySmallText, __assign({ id: labelId, "data-test": "AlertsBodySmallText", "aria-hidden": "true" }, { children: t('alertsBody.rightDescription') })), _jsx(AlertDeliveryButtons, { "data-test": "AlertDeliveryButtons", alertId: alertId, deliveryFormData: alertFormData.delivery, currentDeliveryMethods: allDeliveryMethods, deliveryMethodError: ((_b = alertFormData.dataErrors.find(function (error) { return error.key === 'delivery'; })) === null || _b === void 0 ? void 0 : _b.value)
                    ? t('errorMessages.deliveryMethod')
                    : '', phoneWarning: alertFormData.dataErrors.some(function (error) { return error.key === 'phoneWarning'; }), labelId: labelId, deliveryRef: deliveryRef })] })));
};
export default AlertBodyRight;
